import { axiosDefault } from '@/core/utils';

const fullEnergy = async () => {
	const url = '/tg/boost/refill';
	const response = await axiosDefault.put(url, null);

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};

const upgradeEnergyTank = async () => {
	const url = '/tg/boost/energy';
	const response = await axiosDefault.put(url, null, {});

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};

const upgradeMultiTap = async () => {
	const url = '/tg/boost/stars';
	const response = await axiosDefault.put(url, null, {});

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};

const exchangeShurikens = async (diamonds: number) => {
	const url = `/tg/diamonds/coins/exchange?diamonds=${diamonds}`;
	const response = await axiosDefault.put(url);

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};

const autoclicker = async (diamonds: number) => {
	const url = `/tg/diamonds/unattended?diamonds=${diamonds}`;
	const response = await axiosDefault.put(url);
	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		data: response.data.data,
	};
};

export const HackService = {
	fullEnergy,
	upgradeEnergyTank,
	upgradeMultiTap,
	exchangeShurikens,
	autoclicker,
};
